import * as Actions from "../../actions/cases/allCasesActions";

const initialState = {
  loading: false,
  caseList: [],
  closedCaseList: [],
  filteredCaseList: [],
  casesPerPage: [],
  message: "",
  totalNumberOfRecords: 0,
  activePage: 0,
  recordsPerPage: 20,
  pageRangeDisplayed: 5,
  dateFrom: "",
  dateTo: "",
  status: "",
  appliedDateFrom: "",
  appliedDateTo: "",
  appliedStatus: "",
  statusValues: [],
  searchInput: "",
  searchBasedOn: "",
  createCaseToggle: false,
  caseCreatedSuccess: false,
  isError: false,
  dateFormat: "",
};

const allCasesReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SET_VIEW_CASES_LOADER:
      return {
        ...state,
        loading: action.value,
      };
    // case Actions.GET_ALL_CASES:
    //   return {
    //     ...state,
    //     loading: true,
    //   };
    case Actions.SET_ALL_CASES:
      return {
        ...state,
        // loading: false,
        dateFrom: "",
        dateTo: "",
        status: "All",
        searchInput: "",
        searchBasedOn: "",
        caseList: action.response,
        filteredCaseList: action.response,
        totalNumberOfRecords: action.response.length,
        message: "This list shows closed cases from the last 90 days only.",
        casesPerPage: action.response.slice(0, 20),
        activePage: 1,
        createCaseToggle: false,
        closedCaseList: [],
        appliedDateFrom: "",
        appliedDateTo: "",
        appliedStatus: "All",
        // caseCreatedSuccess: false,
      };
    case Actions.SET_CLOSED_CASES:
      return {
        ...state,
        closedCaseList: action.response,
        // filteredCaseList: action.response,
        // totalNumberOfRecords: action.response.length,
        // message: "This list shows closed cases from the last 90 days only.",
        // casesPerPage: action.response.slice(0, 20),
        // activePage: 1,
      };
    case Actions.CLEAR_CLOSED_CASES:
      return {
        ...state,
        closedCaseList: [],
      };
    case Actions.SET_FILTERED_CASELIST:
      return {
        ...state,
        filteredCaseList: action.value,
      };

    case Actions.SET_CASES_PER_PAGE:
      return {
        ...state,
        casesPerPage: action.value,
      };
    case Actions.SET_CASES_ACTIVE_PAGE:
      return {
        ...state,
        activePage: action.value,
      };
    case Actions.SET_FROM_DATE:
      return {
        ...state,
        dateFrom: action.value,
      };
    case Actions.SET_TO_DATE:
      return {
        ...state,
        dateTo: action.value,
      };
    case Actions.SET_APPLIED_FROM_DATE:
      return {
        ...state,
        appliedDateFrom: action.value,
      };
    case Actions.SET_APPLIED_TO_DATE:
      return {
        ...state,
        appliedDateTo: action.value,
      };
    case Actions.SET_CASES_TOTAL_NUMBER_OF_RECORDS:
      return {
        ...state,
        totalNumberOfRecords: action.value,
      };
    case Actions.SET_SEARCH_INPUT:
      return {
        ...state,
        searchInput: action.value,
      };
    case Actions.SET_SEARCH_BASED_ON:
      return {
        ...state,
        searchBasedOn: action.value,
      };
    case Actions.SET_STATUS: {
      return {
        ...state,
        status: action.value,
      };
    }
    case Actions.SET_APPLIED_STATUS: {
      return {
        ...state,
        appliedStatus: action.value,
      };
    }
    case Actions.TOGGLE_CREATE_CASE: {
      return {
        ...state,
        createCaseToggle: action.value,
      };
    }
    case Actions.SET_CASE_STATUS: {
      return {
        ...state,
        statusValues: action.response,
      };
    }
    case Actions.SET_CASE_CREATED_SUCCESS: {
      return {
        ...state,
        caseCreatedSuccess: action.value,
      };
    }
    case Actions.SET_IS_ERROR: {
      return {
        ...state,
        isError: action.value,
      };
    }
    case Actions.SET_DATE_FORMAT: {
      return {
        ...state,
        dateFormat: action.value,
      };
    }
    case Actions.VIEW_CASES_RESET:
      return initialState;
    default:
      return state;
  }
};

export default allCasesReducer;
